import { cn } from "@/lib/utils";

export function Progress({ value = 0, className = "", label = "Progress" }: { value?: number; className?: string; label?: string }) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div
      className={cn("w-full h-2.5 rounded-full bg-muted", className)}
      role="progressbar"
      aria-valuenow={clamped}
      aria-valuetext={`${clamped}%`}
      aria-label={label}
    >
      <div className="h-2.5 rounded-full bg-primary" style={{ width: `${clamped}%` }} />
    </div>
  );
}
